import Client from '../services/kenticoClient';
import { SortOrder } from 'kentico-cloud-delivery';
import { KENTICO_TYPES } from 'common/consts/kentico';

class ReportsService {
  async fetchReports() {
    const query = Client.items()
      .type(KENTICO_TYPES.REPORT2)
      .orderParameter('elements.rok', SortOrder.desc)
      .elementsParameter([
        'rok',
        'kwartal',
        'raport_pdf',
        'miniaturka',
        'wyniki_finansowe_w_latach_przychod',
        'wyniki_finansowe_w_latach_zysk_strata'
      ]);
    return query.toPromise();
  }

  async fetchSimplifiedReports() {
    const query = Client.items()
      .type(KENTICO_TYPES.REPORT3)
      .orderParameter('elements.rok', SortOrder.desc)
      .elementsParameter([
        'rok',
        'kwartal',
        'raport_pdf',
        'miniaturka',
      ]);
    return query.toPromise();
  }
}

export default new ReportsService();



// WEBPACK FOOTER //
// ./src/services/Reports.service.js